import { useState } from "react";

import {
  AskStrikeUpButton,
  Button,
  Flex,
  Heading,
  HStack,
  RefreshButton,
  Stack,
} from "components/ui";
import { useTranslation } from "hooks/useTranslation";

import AiCallsPanel from "./AiCallsPanel";
import TracesPanel from "./TracesPanel";

type LogsTab = "calls" | "activity";

const TABS: LogsTab[] = ["calls", "activity"];

/**
 * Analytics → AI actions. Two views of the same execution log: one row per AI call (Calls), and one
 * row per user turn with its retries, fallbacks and cost rolled up (Activity). Both are shown to
 * every tenant, gateway feature or not.
 */
const Logs = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState<LogsTab>("calls");
  const [refreshToken, setRefreshToken] = useState(0);

  return (
    <Stack gap={4}>
      <Flex justify="space-between" align="center" wrap="wrap" gap={3}>
        <Heading>{t("app.logs.title")}</Heading>
        <HStack gap={3}>
          <AskStrikeUpButton context={t("app.askStrikeUp.context.logs")} />
          <RefreshButton
            onClick={() => setRefreshToken((token) => token + 1)}
            size="sm"
          />
        </HStack>
      </Flex>

      <HStack gap={2} wrap="wrap">
        {TABS.map((name) => (
          <Button
            key={name}
            intent={tab === name ? "primary" : "secondary"}
            size="sm"
            onClick={() => setTab(name)}
          >
            {t(`app.logs.tabs.${name}`)}
          </Button>
        ))}
      </HStack>

      {tab === "calls" && <AiCallsPanel refreshToken={refreshToken} />}
      {tab === "activity" && <TracesPanel refreshToken={refreshToken} />}
    </Stack>
  );
};

export default Logs;
